import classNames from 'classnames'
import { Text, Image, Link, createCompoundComponent } from '@lounge-fe/ui-kit'
import { ProductFeatureProps } from './types'
import { PropsWithChildren } from 'react'

const Title = ({ children }: PropsWithChildren) => {
  return (
    <Text variant="body-sm" className="font-regular">
      {children}
    </Text>
  )
}

const Content = ({ children }: PropsWithChildren) => {
  return <Text variant="body-sm">{children}</Text>
}

const BaseFeature = ({ children, icon }: ProductFeatureProps): JSX.Element => {
  return (
    <div className="text-center flex flex-col gap-4">
      {icon && (
        <Image className="w-18 h-18 mx-auto" src={icon.src} alt={icon.alt} />
      )}
      <div>{children}</div>
    </div>
  )
}

export const Feature = createCompoundComponent(BaseFeature, {
  Title,
  Content,
})
